/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PhysicianScheduleBlockAliases {
  ACTION_NEW_SCHEDULLE_BLOCK = 'action-new-schedulle-block',
  DATE_PICKER_END_DATE = 'date-picker-end-date',
  DATE_PICKER_START_DATE = 'date-picker-start-date',
  FETCH_SCHEDULE_BLOCK = 'fetch-schedule-block',
  FILTER_FIELD_DATE_END = 'filter-field-date-end',
  FILTER_FIELD_DATE_START = 'filter-field-date-start',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  PANEL_LIST = 'panel-list',
  PHYSICIAN_SCHEDULE_BLOCK_CARD_LIST_DECK = 'physician-schedule-block-card-list-deck',
  PHYSICIAN_SCHEDULE_BLOCK_CONTEXTUAL_BAR = 'physician-schedule-block-contextual-bar',
  PHYSICIAN_SCHEDULE_BLOCK_LEGENDS = 'physician-schedule-block-legends',
  PHYSICIAN_SCHEDULE_CARD_BLOCK = 'physician-schedule-card-block',
  PHYSICIAN_SCHEDULE_FILTERED_LIST = 'physician-schedule-filtered-list',
  PHYSICION_SCHEDULE_BLOCK_LAYOUT = 'physicion-schedule-block-layout',
  PHYSISCIAN_SCHEDULE_FILTER = 'physiscian-schedule-filter',
}
export { PhysicianScheduleBlockAliases };
